// キープ（ストック）機能の純ロジック。localStorage 永続化と語リスト操作。

export const KEEP_LIMIT = 200
export const KEEP_KEY = 'inkyo:keep:v1'

/** 追加（重複は末尾へ移動せず無視）。上限超過時は先頭（古い順）から捨てる。 */
export function addKeep(items: string[], word: string): string[] {
  if (items.includes(word)) return items
  const next = [...items, word]
  return next.length > KEEP_LIMIT ? next.slice(next.length - KEEP_LIMIT) : next
}

export function removeKeep(items: string[], word: string): string[] {
  return items.filter((w) => w !== word)
}

export function loadKeep(storage: Pick<Storage, 'getItem'>): string[] {
  try {
    const raw = storage.getItem(KEEP_KEY)
    if (raw == null) return []
    const parsed: unknown = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    const items = parsed.filter((v): v is string => typeof v === 'string')
    // 過去バージョンや手動編集で上限超過のデータが保存されていても、新しい側 KEEP_LIMIT 件に切り詰める。
    return items.length > KEEP_LIMIT ? items.slice(items.length - KEEP_LIMIT) : items
  } catch {
    return []
  }
}

export function saveKeep(storage: Pick<Storage, 'setItem'>, items: string[]): void {
  try {
    storage.setItem(KEEP_KEY, JSON.stringify(items))
  } catch {
    // プライベートモード等で storage に書けない場合は永続化を諦め、メモリ内のみで動く
  }
}
